// Plugin client per intercettare messaggi dal Service Worker e mostrare banner aggiornamento
// Posiziona questo file in app/plugins così Nuxt lo carica lato client

import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  if (process.server) return;

  const state = reactive({
    updateAvailable: false,
    newVersion: null,
    activatedVersion: null,
  });

  // Espone stato globalmente
  nuxtApp.provide('swUpdateState', state);

  // Ascolta messaggi dal SW
  navigator.serviceWorker?.addEventListener('message', (event) => {
    console.log('[SW] Messaggio ricevuto:', event.data);
    const data = event.data || {};
    if (data.type === 'SW_UPDATE_AVAILABLE') {
      state.updateAvailable = true;
      state.newVersion = data.version;
      console.log('[SW] Aggiornamento disponibile:', data.version);
    }
    if (data.type === 'SW_ACTIVATED') {
      state.activatedVersion = data.version;
            state.updateAvailable = true;
            state.newVersion = data.version;
      console.log('[SW] Nuova versione attiva:', data.version);
    }
  });

  // Funzione per forzare update
  const applyUpdate = async () => {
    const reg = await navigator.serviceWorker.getRegistration();
    if (reg?.waiting) {
      reg.waiting.postMessage({ type: 'SKIP_WAITING' });
    } else if (reg?.installing) {
      console.log('SW sta ancora installando; il refresh lo attiverà quando pronto.');
    }
    // Attendi un attimo e poi ricarica
    setTimeout(() => window.location.reload(), 500);
  };

  nuxtApp.provide('applySwUpdate', applyUpdate);
});
